import { useI18n } from "@/lib/i18n";
import { SectionHeading } from "@/components/Brand";
import { GraduationCap, Camera, Facebook } from "lucide-react";

const PORTRAIT = "/hector-rivera-v3.png";
const BIO_KEYS = ["about.bio1", "about.bio2", "about.bio3", "about.bio4", "about.bio5"];
const EDU_KEYS = ["about.edu1", "about.edu2", "about.edu3"];
const SVC_KEYS = ["about.svc1", "about.svc2", "about.svc3", "about.svc4", "about.svc5"];

export default function About() {
  const { t } = useI18n();
  return (
    <div className="mx-auto max-w-[1500px] px-4 py-14 sm:px-8 lg:px-12 lg:py-20" data-testid="about-page">
      <SectionHeading label={t("brand.positioning")} title={t("about.title")} />

      <div className="mt-12 grid gap-12 lg:grid-cols-[1.1fr_1fr]">
        <div className="space-y-6 text-sm leading-relaxed text-[#5A5752] sm:text-base">
          <p>{t("about.p1")}</p>
          <p>{t("about.p2")}</p>
          <p>{t("about.p3")}</p>
        </div>
        <div className="lg:pt-2">
          <div className="photo-hover overflow-hidden border border-[#C69A3B]/40" data-testid="about-portrait">
            <img
              src={PORTRAIT}
              alt={t("about.name")}
              className="w-full object-contain"
            />
          </div>
          <div className="mt-5 border-l-2 border-[#C69A3B] pl-5">
            <p className="font-serif-display text-2xl text-[#8F3329]" data-testid="about-name">
              {t("about.name")}
            </p>
            <p className="label-mono mt-2">{t("about.role")}</p>
            <a
              href="mailto:hrcreations90@gmail.com"
              data-testid="about-public-email"
              className="mt-3 inline-block text-sm text-[#275E64] underline"
            >
              hrcreations90@gmail.com
            </a>
            <a
              href="https://www.facebook.com/share/1SYWj1kpQz/?mibextid=wwXIfr"
              target="_blank"
              rel="noreferrer"
              data-testid="about-facebook"
              className="mt-2 flex items-center gap-2 text-sm text-[#275E64] underline"
            >
              <Facebook size={14} /> Facebook
            </a>
          </div>
        </div>
      </div>

      <section className="mt-20 border-t border-[#C69A3B]/30 pt-14" data-testid="about-biography">
        <p className="label-mono">{t("about.name")}</p>
        <h2 className="mt-4 max-w-2xl font-serif-display text-3xl leading-tight text-[#8F3329] sm:text-4xl">
          {t("about.bioTitle")}
        </h2>
        <div className="gold-rule mt-6 w-24" />
        <div className="mt-9 grid gap-x-14 gap-y-6 text-sm leading-relaxed text-[#5A5752] sm:text-base lg:grid-cols-2">
          {BIO_KEYS.map((key) => (
            <p key={key} data-testid={`about-${key.split(".")[1]}`}>
              {t(key)}
            </p>
          ))}
        </div>
      </section>

      <div className="mt-16 grid gap-8 lg:grid-cols-2">
        <section className="border border-[#C69A3B]/30 bg-[#FAFAF7] p-8" data-testid="about-education">
          <GraduationCap size={22} className="text-[#C69A3B]" />
          <h3 className="mt-4 font-serif-display text-2xl text-[#252525]">{t("about.educationTitle")}</h3>
          <ul className="mt-6 space-y-4 text-sm text-[#5A5752] sm:text-base">
            {EDU_KEYS.map((key) => (
              <li key={key} className="border-l border-[#C69A3B]/50 pl-4" data-testid={`about-${key.split(".")[1]}`}>
                {t(key)}
              </li>
            ))}
          </ul>
        </section>
        <section className="border border-[#C69A3B]/30 bg-[#FAFAF7] p-8" data-testid="about-services">
          <Camera size={22} className="text-[#C69A3B]" />
          <h3 className="mt-4 font-serif-display text-2xl text-[#252525]">{t("about.servicesTitle")}</h3>
          <ul className="mt-6 space-y-4 text-sm text-[#5A5752] sm:text-base">
            {SVC_KEYS.map((key) => (
              <li key={key} className="border-l border-[#C69A3B]/50 pl-4" data-testid={`about-${key.split(".")[1]}`}>
                {t(key)}
              </li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
}
